var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    "data-bbox": "25 33 150 134",
    "data-type": "color",
    viewBox: "25 33 150 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-m69434ay3__item-ker6vm4a svg [data-color=&quot;1&quot;]{fill:#1d0e03}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43aaef",
    d: "M100 33 25 167h150L100 33z",
    "data-color": 1,
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#43aaef",
    d: "M116.5 62.6 58.1 167H175L116.5 62.6z",
    "data-color": 1,
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#43aaef",
    d: "M83.5 62.6 25 167h116.9L83.5 62.6z",
    "data-color": 1,
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#43aaef",
    d: "M133.1 92.2 91.3 167H175l-41.9-74.8z",
    "data-color": 1,
    opacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#43aaef",
    d: "M149.6 121.7 124.2 167H175l-25.4-45.3zM66.9 92.2 25 167h83.7L66.9 92.2z",
    "data-color": 1,
    opacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#43aaef",
    d: "M50.4 121.7 25 167h50.8l-25.4-45.3z",
    "data-color": 1,
    opacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#43aaef",
    d: "m166.1 151.1-8.9 15.9H175l-8.9-15.9zM33.9 151.1 25 167h17.8l-8.9-15.9zM124.2 167h17.7l-8.8-15.9-8.9 15.9zM91.3 167h17.4l-8.7-15.6-8.7 15.6zM58.1 167h17.7l-8.9-15.9-8.8 15.9z",
    "data-color": 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.ec8c428b7a1a48b783d11f52340ab5d4.svg";
export { ForwardRef as ReactComponent };